'use strict';

module.exports = tableCell;

function tableCell(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/table-cell.js
// module id = 980
// module chunks = 95715928098905 168707334958949